module.exports = __webpack_public_path__ + "img/logintu.dcf1b507.png";